<template>
  <b-overlay
    id="overlay-background"
    :show="modulesLoader || !autoTerminateInfoResolved"
    variant="dark"
    opacity="0.85"
    blur="2px"
    rounded="sm"
    spinner-variant="primary"
    spinner-medium
  >
    <b-row
      v-if="showAutoTerminateInfo && autoTerminateInfoResolved"
      class="mb-1"
    >
      <b-col sm="12">
        <b-card
          class="processcompletedmessage"
        >
          <b-alert
            variant="warning"
            class="processcompletedmessagealert"
            show
          >
            <div class="alert-body">
              <span>{{ autoTerminateInfoMessage }}</span>
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      v-if="!showAutoTerminateInfo && rkiAwait"
      class="mb-1"
    >
      <b-col sm="12">
        <b-card
          class="processcompletedmessage"
        >
          <b-alert
            variant="warning"
            class="processcompletedmessagealert"
            show
          >
            <div class="alert-body">
              <span>{{ $t('DEBTIA_RKI_WAITING_APPROVAL') }}</span>
              <small v-if="rkiRegDate">
                ({{ $t('DEBTIA_REGISTER_ON') }} {{ $i18n.locale === 'en' ? rkiRegDate.en_date_format : rkiRegDate.da_date_format }})
              </small>
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      v-if="!showAutoTerminateInfo && caseProcessesCompleted && autoTerminateInfoResolved"
    >
      <b-col sm="12">
        <b-card
          class="processcompletedmessage"
        >
          <b-alert
            variant="primary"
            class="processcompletedmessagealert"
            show
          >
            <div class="alert-body">
              <span>{{ $t('DEBTIA_PROCESS_COMPLETED') }}</span>
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row
      v-else-if="!showAutoTerminateInfo && autoTerminateInfoResolved"
    >
      <b-col sm="4">
        <b-list-group>
          <b-list-group-item
            href="#"
            active
          >
            {{ $t('DEBTIA_CURRENT_MODULE') }}
          </b-list-group-item>
          <b-list-group-item
            v-if="active_module && active_module.module_settings"
            href="#"
          >
            <template v-if="active_module.module_settings.awaitedDays > 0">
              {{ active_module.module_title ? active_module.module_title : 'N/A' }}
              {{ active_module.module_id === 1 ? `(${active_module.module_settings.awaitedDays} ${$t('DEBTIA_DAYS_LEFT')})` : '' }}
            </template>
            <template v-else-if="active_module.module_settings.execution_date">
              <div
                v-if="active_module.module_settings.description"
                class="mb-1"
              >
                {{ active_module.module_title ? active_module.module_title : 'N/A' }}
                ({{ $t('DEBTIA_CASE_CONTINUE_ON') }} {{ ($i18n.locale === 'en') ? active_module.module_settings.en_execution_date : active_module.module_settings.da_execution_date }})
              </div>
              <b-alert
                variant="info"
                show
              >
                <div class="alert-body">
                  <span>
                    <strong>{{ $t('DEBTIA_DESCRIPTION') }}:</strong>
                    {{ active_module.module_settings.description }}
                  </span>
                </div>
              </b-alert>
            </template>
            <template v-else>
              {{ active_module.module_title ? active_module.module_title : 'N/A' }}
              {{
                (active_module.module_settings.awaitedDays === 0 && active_module.module_settings.awaitDescription)? `(${ $t(active_module.module_settings.awaitDescription) })`: ''
              }}

              <div>
                <b-alert
                  v-if="active_module.module_settings.execution_msg && errorMsg.length === 0"
                  variant="info"
                  show
                  class="mt-1 p-1"
                >
                  {{ active_module.module_settings.execution_msg }}
                </b-alert>
              </div>
            </template>

            <b-row>
              <b-col v-if="errorMsg.length > 0">
                <div>
                  <b-alert
                    id="process-error"
                    variant="danger"
                    class="mt-1"
                    show
                  >
                    <div
                      v-for="(error, index) in errorMsg"
                      :key="index+error"
                    >
                      <span>{{ error }}</span>
                    </div>
                  </b-alert>
                </div>
              </b-col>
            </b-row>

          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col sm="4">
        <b-list-group>
          <b-list-group-item
            href="#"
            active
          >
            {{ $t('DEBTIA_NEXT_MODULE') }}
          </b-list-group-item>
          <b-list-group-item
            href="#"
          >
            {{ next_module.module_title ? next_module.module_title : 'N/A' }}
          </b-list-group-item>
        </b-list-group>
      </b-col>
      <b-col sm="4">
        <b-list-group>
          <b-list-group-item
            href="#"
            active
          >
            {{ $t('DEBTIA_PROCESSES') }}
          </b-list-group-item>
          <template v-if="processCases.length > 0">
            <div
              v-for="(data,index) in processCases"
              :key="index+data.title"
            >
              <b-list-group-item :href="`/process/view/${data.process_id}`">
                {{ data.title }}
              </b-list-group-item>
            </div>
          </template>
          <template v-else>
            <div>
              <b-list-group-item>
                {{ $t('DEBTIA_NO_ACTIVE_PROCESS_TEXT') }}
              </b-list-group-item>
            </div>
          </template>
        </b-list-group>
      </b-col>
      <b-col
        v-if="caseUserActions"
        sm="4"
        class="user-action-buttons"
      >
        <b-list-group>
          <b-list-group-item
            href="#"
            active
          >
            User Action Buttons
          </b-list-group-item>
          <b-list-group-item
            v-if="caseUserActions.await"
          >
            <strong>{{ $t('DEBTIA_AWAIT_DAYS_LEFT').replace('X', caseUserActions.await_days) }}</strong>
          </b-list-group-item>
          <b-list-group-item>
            <strong>Description: </strong> {{ caseUserActions.description }}
          </b-list-group-item>
          <b-list-group-item
            v-if="caseStateData && caseStateData.state === 'pause'"
          >
            <b-alert
              variant="warning"
              show
            >
              <div class="alert-body">
                <span>This case is put in pause by {{ caseStateData.employee_name }} until {{ getFormatedDate(caseStateData.pause_date) }} because of {{ caseStateData.description }}.</span>
              </div>
            </b-alert>
          </b-list-group-item>
          <b-list-group-item
            v-if="caseStateData && isInstallmentPlanActive === 1"
          >
            <b-alert
              variant="warning"
              show
            >
              <div class="alert-body">
                <span>An installment plan is currently active for this case. Once the installment plan ends, the process will resume.</span>
              </div>
            </b-alert>
          </b-list-group-item>
          <b-list-group-item
            v-else-if="caseUserActions.recipient === 'client' || caseUserActions.recipient === 'partner'"
          >
            <template v-for="(data, index) in caseUserActions.buttons">
              <b-button
                v-if="!data.await"
                :key="index+data.id"
                :variant="getBtnVariant(data.button_color)"
                class="user-action-button"
                @click="userActionBtnClicked(data.id, caseUserActions.process_id, 1, null)"
              >
                {{ data.button_title }}
              </b-button>
            </template>
          </b-list-group-item>
          <b-list-group-item
            v-else
          >
            <template v-for="(data, index) in caseUserActions.buttons">
              <b-button
                v-if="!data.await"
                :key="index+data.id"
                :variant="getBtnVariant(data.button_color)"
                class="user-action-button"
                @click="userActionBtnClicked(data.id, caseUserActions.process_id, 2, null)"
              >
                {{ data.button_title }}
              </b-button>
            </template>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <b-row
      v-if="active_module.module_id === 25 && ContentConditionModule.length"
      class="mt-1"
    >
      <b-col sm="12">
        <!-- <b-card> -->
        <b-list-group>
          <b-list-group-item
            href="#"
            active
          >
            {{ $t('DEBTIA_PRIMARY_PROCESS') }}
          </b-list-group-item>
          <b-list-group-item>
            <b-alert
              variant="warning"
              class="p-1 mb-0"
              show
            >
              <div class="font-weight-bold mb-1 text-body">
                {{ $t('DEBTIA_AWAITING_FILES') }}:
              </div>

              <div
                v-for="(row, index) in ContentConditionModule"
                :key="index"
                class="mb-0"
                :class="getAwaitingFileTextClass(row.warning)"
              >
                <strong>{{ row.file_category }}</strong>:
                {{ row.counter }}
                <span v-if="row.info_message">
                  - {{ row.info_message }}
                </span>
              </div>
            </b-alert>
          </b-list-group-item>
        </b-list-group>
        <!-- </b-card> -->
      </b-col>
    </b-row>
    <b-row
      v-if="(secondaryModules.length > 0 || secondaryProcessUserActions.length > 0) || secondaryAwaitingFiles.length > 0"
    >
      <template
        v-if="secondaryModules.length > 0"
      >
        <b-col
          v-for="(secondaryModule, index) in secondaryModules"
          :key="index+secondaryModule.module"
          sm="4"
          class="user-action-buttons"
        >
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              Secondary Process: {{ secondaryModule.module }}
            </b-list-group-item>
            <b-list-group-item>
              <b-alert
                variant="danger"
                show
              >
                <div class="alert-body">
                  {{ JSON.parse(secondaryModule.error)[0] }}
                </div>
              </b-alert>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </template>
      <template
        v-if="secondaryProcessUserActions.length > 0"
      >
        <b-col
          v-for="(userAction, index) in secondaryProcessUserActions"
          :key="index+userAction.await"
          sm="4"
          class="user-action-buttons"
        >
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              Secondary Process: User Action Buttons
            </b-list-group-item>
            <b-list-group-item
              v-if="userAction.await"
            >
              <strong>{{ $t('DEBTIA_AWAIT_DAYS_LEFT').replace('X', userAction.await_days) }}</strong>
            </b-list-group-item>
            <b-list-group-item>
              <strong>Description: </strong> {{ userAction.description }}
            </b-list-group-item>
            <b-list-group-item
              v-if="caseStateData && caseStateData.state === 'pause'"
            >
              <b-alert
                variant="warning"
                show
              >
                <div class="alert-body">
                  <span>This case is put in pause by {{ caseStateData.employee_name }} until {{ getFormatedDate(caseStateData.pause_date) }} because of {{ caseStateData.description }}.</span>
                </div>
              </b-alert>
            </b-list-group-item>
            <b-list-group-item
              v-if="userAction.recipient === 'client' || userAction.recipient === 'partner'"
            >
              <template v-for="(data, btnindex) in userAction.buttons">
                <b-button
                  v-if="!data.await"
                  :key="btnindex+data.id"
                  :variant="getBtnVariant(data.button_color)"
                  class="user-action-button"
                  @click="userActionBtnClicked(data.id, userAction.process_id, 1, userAction)"
                >
                  {{ data.button_title }}
                </b-button>
              </template>
            </b-list-group-item>
            <b-list-group-item
              v-else
            >
              <template v-for="(data, uaIndex) in userAction.buttons">
                <b-button
                  v-if="!data.await"
                  :key="uaIndex+data.id"
                  :variant="getBtnVariant(data.button_color)"
                  class="user-action-button"
                  @click="userActionBtnClicked(data.id, userAction.process_id, 2, userAction)"
                >
                  {{ data.button_title }}
                </b-button>
              </template>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </template>
      <template v-if="secondaryAwaitingFiles.length > 0">
        <b-col
          v-for="(secProcess, index) in secondaryAwaitingFiles"
          :key="'sec-awaiting-' + index"
          class="user-action-buttons"
        >
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              {{ $t('DEBTIA_SECONDARY_PROCESS') }}: {{ secProcess.process_title || secProcess.current_module }}
            </b-list-group-item>
            <b-list-group-item>
              <b-alert
                variant="warning"
                class="p-1 mb-0"
                show
              >
                <div class="font-weight-bold mb-1 text-body">
                  {{ $t('DEBTIA_AWAITING_FILES') }}:
                </div>
                <div
                  v-for="(row, rowIndex) in secProcess.awaiting_files"
                  :key="rowIndex"
                  class="mb-0"
                  :class="getAwaitingFileTextClass(row.warning)"
                >
                  <strong>{{ row.file_category }}</strong>: {{ row.counter }}
                  <span v-if="row.info_message">
                    - {{ row.info_message }}
                  </span>
                </div>
              </b-alert>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </template>
    </b-row>

    <b-modal
      id="user-action-modal"
      ref="user-action-modal"
      centered
      title="Button Action"
      ok-title="Submit"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      @show="resetModal"
      @hidden="resetModal"
      @ok="validationButtonForm"
    >
      <b-overlay
        id="overlay-background"
        :show="btnloader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <validation-observer ref="buttonRules">
          <b-form>
            <b-alert
              v-if="buttonError"
              variant="warning"
              show
            >
              <div class="alert-body">
                {{ buttonError }}
              </div>
            </b-alert>
            <b-row>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DESCRIPTION')"
                  label-for="description"
                  class="mb-2"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Description"
                    rules="required"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="description"
                      :placeholder="$t('DEBTIA_DESCRIPTION')"
                      rows="8"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_FILE')"
                  label-for="description"
                  class="mb-2"
                >
                  <validation-provider
                    v-slot="{ validate, errors }"
                    name="File"
                    rules="required"
                  >
                    <b-form-file
                      id="file-default"
                      ref="button-file"
                      @change="validate($event)"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-overlay>
    </b-modal>
    <r-k-i-module
      ref="modalRKIModule"
      :process-i-d="rkiProcessID"
      :show-skip-modal="showSkipModel"
      :rki-await-deletion="rkiAwaitDeletion"
      :rki-customer-id="rkiCustomerId"
      :manual-r-k-i-entries="manualRKIEntries"
    />
    <bailiff-process-modal
      ref="modalBailiffProcess"
      :process-id="Number(rkiProcessID)"
    />
    <skip-modal
      ref="modalSkipModule"
      :msg="skipMsg"
      :case-id="Number(caseId)"
      :process-id="Number(rkiProcessID)"
    />
    <user-action-reason-modal
      ref="reasonPopup"
      :reason="reason"
      :process-id="processId"
      :case-id="caseId"
      :open-file-proof="openFileProof"
      :user-action-button-clicked="userActionButtonClicked"
      :recipient-type="recipientType"
    />
    <bailiff-modal
      ref="modalBailiff"
      :case-id="caseId"
      :reload-method="onBailiffReload"
      :switch-loader="setModulesLoader"
    />
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BListGroup, BListGroupItem, BOverlay, BModal, BForm, BFormGroup, BFormFile, BFormTextarea,
  BButton,
  BCard, BAlert,
} from 'bootstrap-vue'
// import store from '@/store'
import { EventBus } from '@/event-bus'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from '@axios'
import constants from '@/app-configs/constants'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import RKIModule from './RKIModule.vue'
import skipModal from './SkipModal.vue'
import BailiffProcessModal from './BailiffProcessModal.vue'
import userActionReasonModal from './userActionReasonModal.vue'
import BailiffModal from './BailiffModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    BButton,
    BCard,
    BAlert,
    BOverlay,
    BModal,
    BFormGroup,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormTextarea,
    RKIModule,
    skipModal,
    BailiffProcessModal,
    userActionReasonModal,
    BailiffModal,
  },
  directives: {
    Ripple,
  },
  props: {
    caseStateData: {
      type: Object,
      required: true,
    },
    caseCreatedAt: {
      type: String,
      default: null,
    },
    caseStatus: {
      type: Number,
      default: null,
    },
    isFullyPaidActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modulesLoader: true,
      active_module: [],
      next_module: [],
      processCases: [],
      caseProcessesCompleted: 0,
      caseUserActions: {},
      description: '',
      buttonError: '',
      btnloader: false,
      rkiProcessID: 0,
      rkiAwait: false,
      rkiAwaitDeletion: '',
      constants,
      caseId: this.$route.params.id,
      skipMsg: '',
      isInstallmentPlanActive: 0,
      errorMsg: [],
      reason: {},
      processId: 0,
      recipientType: 0,
      clickedBtnId: 0,
      reasonCheck: 0,
      reasonDescription: '',
      secondaryProcessUserActions: [],
      secondaryModules: [],
      rkiCustomerId: true,
      manualRKIEntries: [],
      user_role: JSON.parse(localStorage.getItem('userData')).role[0],
      rkiRegDate: [],
      ContentConditionModule: [],
      gracePeriodDays: 7,
      isCaseFullyPaid: null,
      secondaryAwaitingFiles: [],
      checkRefreshStateOnSecondaryUpdate: false,
    }
  },
  computed: {
    autoTerminateInfoResolved() {
      return this.isCaseFullyPaid !== null
    },
    caseCreationDate() {
      if (!this.caseCreatedAt) return null
      const date = new Date(this.caseCreatedAt)
      return Number.isNaN(date.getTime()) ? null : date
    },
    caseTerminateDate() {
      if (!this.caseCreationDate) return null
      const date = new Date(this.caseCreationDate.getTime())
      date.setDate(date.getDate() + this.gracePeriodDays)
      return date
    },
    daysLeftUntilTerminate() {
      if (!this.caseTerminateDate) return null
      const msPerDay = 1000 * 60 * 60 * 24
      const diffMs = this.caseTerminateDate.getTime() - new Date().getTime()
      return Math.max(0, Math.ceil(diffMs / msPerDay))
    },
    isWithinGracePeriod() {
      if (!this.caseCreationDate) return false
      const msPerDay = 1000 * 60 * 60 * 24
      const ageDays = Math.floor((new Date().getTime() - this.caseCreationDate.getTime()) / msPerDay)
      return ageDays <= this.gracePeriodDays
    },
    isCaseActive() {
      return this.caseStatus === 1 || this.caseStatus === 4
    },
    showAutoTerminateInfo() {
      return this.isCaseActive
        && this.isCaseFullyPaid === true
        && this.isWithinGracePeriod
        && this.caseCreationDate !== null
    },
    autoTerminateInfoMessage() {
      if (!this.showAutoTerminateInfo) return ''
      const createdDate = this.formatLocalizedDate(this.caseCreationDate)
      const terminateDate = this.formatLocalizedDate(this.caseTerminateDate)
      const daysLeft = this.daysLeftUntilTerminate
      return this.$t('DEBTIA_CASE_FULLY_PAID_AUTO_TERMINATE_INFO')
        .replace(':CREATED_DATE', createdDate)
        .replace(':TERMINATE_DATE', terminateDate)
        .replace(':DAYS_LEFT', daysLeft)
    },
  },
  created() {
    EventBus.$on('refreshModules', () => {
      this.getModuleDetails()
    })
    EventBus.$on('isCaseFullyPaid', isCaseFullyPaid => {
      this.isCaseFullyPaid = isCaseFullyPaid
    })
    EventBus.$on('refreshSecondaryModules', obj => {
      this.secondaryProcessUserActions = obj.userActionModule
      const { otherModules } = obj
      this.secondaryAwaitingFiles = otherModules.filter(m => m.awaiting_files && m.awaiting_files.length > 0)
      this.secondaryModules = []
      otherModules.forEach(element => {
        if (element.error) {
          const secondaryObj = {
            error: element.error,
            module: element.current_module,
          }
          this.secondaryModules.push(secondaryObj)
        }
      })
      if (
        this.checkRefreshStateOnSecondaryUpdate
        && obj.isProcessCasesEmpty
        && Array.isArray(this.active_module)
        && this.active_module.length === 0
      ) {
        EventBus.$emit('refreshStateData')
      }
      this.checkRefreshStateOnSecondaryUpdate = false
    })
  },
  methods: {
    async fetchInitialData() {
      await this.getModuleDetails()
    },
    userActionBtnClicked(id, processId, recipientType, userActionObject) {
      let reason = {}
      if (userActionObject) {
        reason = userActionObject.buttons.find(item => item.id === id)
      } else {
        reason = this.caseUserActions.buttons.find(item => item.id === id)
      }
      this.reason = reason
      this.processId = processId
      this.recipientType = recipientType
      this.clickedBtnId = reason.id
      if (reason.reason) {
        setTimeout(() => {
          this.$refs.reasonPopup.open()
        }, 100)
      } else if (recipientType === 2) {
        this.userActionButtonClicked(id, processId, 0, '')
      } else {
        this.openFileProof(0, '')
      }
    },
    openFileProof(reason, reasonDescription) {
      this.$refs['user-action-modal'].show()
      this.reasonCheck = reason
      this.reasonDescription = reasonDescription
    },
    showSkipModel(msg) {
      this.skipMsg = msg
      this.$refs.modalSkipModule.$children[0].show()
    },
    validationButtonForm(evt) {
      evt.preventDefault()
      this.$refs.buttonRules.validate().then(success => {
        const file = this.$refs['button-file'].files[0]
        const form = new FormData()
        form.append('process_id', this.processId)
        form.append('description', this.description)
        form.append('button_id', this.clickedBtnId)
        form.append('case_id', this.caseId)
        form.append('file_proof', file)
        form.append('reason', this.reasonCheck)
        form.append('reason_description', this.reasonDescription)
        if (success) {
          this.btnloader = true
          const url = '/process/case/run-button-module'
          axios.post(url, form).then(async response => {
            if (response.status === 200) {
              this.btnloader = false
              this.$refs['user-action-modal'].hide()
              await this.getModuleDetails()
              this.checkRefreshStateOnSecondaryUpdate = true
              EventBus.$emit('refreshLogs')
              EventBus.$emit('refreshSecondaryProcesses')
            }
          }).catch(e => {
            this.btnloader = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Failed',
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: this.$t(e.response.data.message[0]),
              },
            })
          })
        }
      })
    },
    getFormatedDate(value) {
      const currentDate = new Date(value)
      // Define the date format options
      const dateFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }

      // Format the date
      const formattedDate = new Intl.DateTimeFormat('en-US', dateFormatOptions).format(currentDate)
      return formattedDate
    },
    formatLocalizedDate(value) {
      if (!value) return ''
      const date = value instanceof Date ? value : new Date(value)
      if (Number.isNaN(date.getTime())) return ''
      const localeTag = this.$i18n.locale === 'en' ? 'en-US' : 'da-DK'
      const dateFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }
      return new Intl.DateTimeFormat(localeTag, dateFormatOptions).format(date)
    },
    getBtnVariant(variant) {
      const btncolor = variant.includes('#') ? 'relief-primary' : `relief-${variant.toLowerCase()}`
      return btncolor
    },
    getAwaitingFileTextClass(warning) {
      if (!warning) return ''
      const color = String(warning).toLowerCase()
      const aliasMap = {
        yellow: 'warning',
      }
      return `text-${aliasMap[color] || color}`
    },
    async getModuleDetails() {
      this.modulesLoader = true
      const caseID = this.$route.params.id
      const url = `${constants.baseUrlV2}/debt-case/process-data/${caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.rkiAwait = response.data.data.rkiAwait
          this.rkiRegDate = response.data.data.rkiRegDate
          this.rkiAwaitDeletion = response.data.data.rkiAwaitDeletion
          this.manualRKIEntries = response.data.data.manualRKIEntries
          const processData = response.data.data.process_data
          const activeModule = processData ? processData.active_module : null
          this.active_module = activeModule
          this.next_module = processData ? processData.next_module : null
          this.rkiCustomerId = response.data.data.rki_customer_id
          this.processCases = response.data.data.process_cases
          this.errorMsg = response.data.data.process_cases.length > 0 && response.data.data.process_cases[0].error ? JSON.parse(response.data.data.process_cases[0].error) : []
          this.caseUserActions = response.data.data.userActions
          this.isInstallmentPlanActive = response.data.data.is_installment_plan_active
          this.caseProcessesCompleted = response.data.data.process_cases && response.data.data.process_cases.length > 0 ? response.data.data.process_cases[0].completed : false
          this.modulesLoader = false
          const processCases = response.data.data.process_cases
          const processID = processCases.length > 0 ? processCases[0].process_id : 0
          this.rkiProcessID = processID
          const ProcessCaseId = processCases.length > 0 ? processCases[0].id : 0
          EventBus.$emit('getFirstProcessId', processID)
          if ((processData.active_module.module_id === 20 && !this.rkiAwait)
            && (this.$ability.can(this.constants.action.permissionRkiRegistration, this.constants.resource.user))) {
            this.$refs.modalRKIModule.$children[0].show()
          }
          if (processData.active_module.module_id === 22) {
            this.$refs.modalBailiffProcess.$children[0].show()
          }
          if (processData.active_module.module_id === 17) {
            this.$nextTick(() => {
              if (this.$refs.modalBailiff) {
                this.$refs.modalBailiff.open()
              }
            })
          }
          if (response.data.data.process_data.active_module.module_id === 25) {
            const contentConditionSettings = response.data.data.process_data.active_module.module_settings
            if (contentConditionSettings) {
              this.ContentConditionModule = contentConditionSettings
            }
          }
          if (processData) {
            if (processData.active_module.module_id === 24
              && processData.active_module.module_settings.execution_date === null) {
              const awaitQuestion = processData.active_module.module_settings.question ?? ''
              const processName = processCases.length > 0 ? (processCases[0].process_name ?? '') : ''
              EventBus.$emit('queueAwaitModal', {
                question: awaitQuestion, processCaseId: ProcessCaseId, source: 'primary', processName,
              })
            }
          }
          EventBus.$emit('primaryModalCheckDone')
        }
      })
    },
    userActionButtonClicked(buttonId, processId, reason, reasonDescription) {
      this.modulesLoader = true
      const caseId = this.$route.params.id
      const form = new FormData()
      form.append('process_id', processId)
      form.append('button_id', buttonId)
      form.append('case_id', caseId)
      form.append('reason', reason)
      form.append('reason_description', reasonDescription)
      const url = '/process/case/run-button-module'
      axios.post(url, form).then(async response => {
        if (response.status === 200) {
        // this.loader = false
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'Action performed on button.',
            },
          })
          await this.getModuleDetails()
          this.checkRefreshStateOnSecondaryUpdate = true
          EventBus.$emit('refreshLogs')
          EventBus.$emit('refreshSecondaryProcesses')
        }
      }).catch(e => {
        this.modulesLoader = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Failed',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: this.$t(e.response.data.message[0]),
          },
        })
      })
    },
    resetModal() {
      this.description = ''
      this.buttonError = ''
    },
    setModulesLoader() {
      this.modulesLoader = true
    },
    onBailiffReload() {
      this.getModuleDetails()
    },
  },
}
</script>

<style lang="scss">
#process-error {
  padding: 10px;
}
</style>
